module.exports = __webpack_public_path__ + "img/신한카드.5f823587.png";